import { appSidebar, SelectAppProps } from 'services/analytics/events';

export const trackingVerticalNavigationselectActivityFeedClick = () => {
  appSidebar.selectActivityFeed();
  return;
};

export const trackingVerticalNavigationMyDocumentsClick = () => {
  appSidebar.selectMyDocuments();
  return;
};

export const trackingVerticalNavigationAppClick = (integrationType: string) => {
  const metadata: SelectAppProps = {
    '[Metadata] App type': integrationType,
  };
  appSidebar.selectApp(metadata);
  return;
};

export const trackingVerticalNavigationUserProfileClick = () => {
  appSidebar.selectProfileUser();
  return;
};
